<!-- APP--APP管理--商品配置 -->
<template>
  <div :style="{'text-align':'center'}">
    <!-- 表单 -->
    <div>
      <!-- 表单-商品选择-二级商品类型 + 已选择部分 -->
      <md-table class="select-table" :style="{'text-align':'left'}" @md-selected="table_selectCloud" :md-selected-value.sync="form" v-model="table_goods">
        <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="multiple" md-auto-select>
              <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('good_name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('company_name')">{{ item.comp_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('effect_month')">{{ item.month }}</md-table-cell>
              <md-table-cell :md-label="$I18n('cost')">
                <div>
                  <p :style="{'margin':0}" v-for="i in item._list_price_list" :key="i.key">{{i.key}}: {{i.value}}</p>
                </div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('fact_fee')">
                <div>
                  <p :style="{'margin':0}" v-for="i in item._final_price_list" :key="i.key">{{i.key}}: {{i.value}}</p>
                </div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('only_buy_1')">{{ item.only == 2 ?$I18n("close") :$I18n("open") }}</md-table-cell>
        </md-table-row>
        <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
      </md-table>
      <!-- 翻页 -->
      <table-page :total="total" :pageSize="pageSize" v-model="pageNo"/>
    </div>
    <!-- 提交按钮 -->
    <md-button class="md-info right-button" @click="modal_openModal">{{$I18n("sure")}}</md-button>
    <!-- 弹窗 -->
    <modal key="main" v-show="modal" @close="modal_closeModal" class="lg-modal">
      <!-- 弹窗-头部 -->
      <template slot="header">
        <h4 class="modal-title">{{$I18n("tips")}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_closeModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <!-- 弹窗-主体 -->
      <template slot="body">
        <div>{{$I18n("is_sure_edit")}}</div>
      </template>
      <!-- 弹窗-底部按钮 -->
      <template slot="footer">
        <md-button @click="modal_submit" class="left-icon md-info">{{$I18n("sure")}}</md-button>
        <md-button @click="modal_closeModal" class="">{{$I18n("cancel")}}</md-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Modal } from '@/components';
export default {
  components: {
    Modal,
  },
  props: {
    app_id : {
      type: String,
      default: "",
    },
    comps: {
      type: Array,
      default: () => [],
    },
    comp_id:{
      // type: String,
      default: "",
    },
    comp_path: {
      default: "",
    },
  },
  data(){
    return {
      typeData: [],
      selectAll : false, // 一级商品菜单-是否全选
      form  : [],        // 表格选中的商品
      goods : [],     // 所有的商品的数据列表
      modal : false,  // 是否打开弹窗
      pageSize: 6,
      pageNo : 1,
      total  : 0,
    }
  },
  computed:{
    isIndeterminate() { // 表单-一级商品-非全选时状态
      const checkedLength = this.form.main.length;
      return checkedLength > 0 && checkedLength < this.goodShow.length;
    },
    table_goods() {
      return [...this.goods].slice((this.pageNo - 1) * this.pageSize, this.pageNo * this.pageSize)
    },
  },
  methods: {
    table_selectCloud (item){ // 表格-选择云存储
      console.log(item)
      this.form = item
    },
    modal_openModal (){ // 弹窗-打开弹窗
      this.modal = true;
    },
    modal_closeModal(){ // 弹窗-关闭弹窗
      this.modal = false;
    },
    modal_submit(){ // 弹窗-提交修改
      return this.$api.setAppProduct({ // api: /mall/goods/rela/set
        ids: this.form.map(i => i.id),
        link_type: 2,
        app_id : this.app_id,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.modal_closeModal();
          this.api_getGoodSet();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    api_getType (){
      return  this.$api.getGoodClass({ })
        .then(this.$Then(res => {
          this.typeData = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    api_getGoodSet(){ // API-获取对应 "APP ID" 的商品列表
      this.form = [];
      return this.$api.getAppProduct({ // api: /mall/category/query
        "link_type"  : 2,
        "app_id"     : this.app_id,
        "page_index" : 1,
        "page_size"  : 9999,
      })
        .then(this.$Then(res => {
          let ids = res.data.map(i => {
            return i.link_id;
          })
          console.log(ids)
          console.log(this.goods.filter(good => {
            return ids.includes(good.id)
          }))
          this.form =  this.goods.filter(good => {
            return ids.includes(good.id)
          })
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    api_getAllGood(){ // API-获取所有的Good
      return this.$api.getGood({ // api: /mall/category/query
        "comp_id"    : this.comp_id  ,
        "comp_path"  : this.comp_path,
        "seller_id"  : "",
        "app_id"     : "",
        "category_id": 0,
        "page_index" : 1,
        "page_size"  : 9999,
      })
        .then(this.$Then(res => {
          this.total = res.count;
          this.goods = res.data.map(item => {
            let type_name = "";
            let typeInfo = this.typeData.filter(type => {
              return type.id === item.category_id
            })
            if(typeInfo.length > 0){
              type_name = typeInfo[0].name
            }

            var cost_price_list = [];
            if(item.cost_price){
              const cost_price_json = JSON.parse(item.cost_price);
              for(var cost_key in cost_price_json){
                cost_price_list.push({key: cost_key, value: cost_price_json[cost_key]})
              }
            }
            var list_price_list = [];
            if(item.list_price){
              const list_price_json = JSON.parse(item.list_price);
              for(var list_key in list_price_json){
                list_price_list.push({key: list_key, value: list_price_json[list_key]})
              }
            }
            var final_price_list = [];
            if(item.final_price){
              const final_price_json = JSON.parse(item.final_price);
              for(var final_key in final_price_json){
                final_price_list.push({key: final_key, value: final_price_json[final_key]})
              }
            }
            
            return {
              ...item,
              type_name,
              _cost_price_list : cost_price_list,
              _list_price_list : list_price_list,
              _final_price_list : final_price_list,
            }
          });
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
  },
  created(){
    this.api_getType()
      .then(() => {
        return this.api_getAllGood()
      })
      .then(() => {
        if(this.app_id){
          this.api_getGoodSet()
        }
      })
  },
}
</script>
<style lang="scss" scoped>
  .left-transfer-item{
    margin-right : 24px;
  }
  .left-transfer-item,
  .right-transfer-item{
    text-align: left;
    display: inline-block;
  }
  .select-table{
    & .md-selected{
      background-color: unset !important;
    }
  }
</style>